import { salesRoutes } from "@nju/routes";
import { IExtendedOnboardingOrchestratorState } from "./types";

export function resolvePathFromOrchestratorState(
  state: IExtendedOnboardingOrchestratorState,
): string {
  switch (state) {
    case "START":
      return salesRoutes.panel.path();

    case "ITEM_SELECTION":
      return salesRoutes.czyZachowacNumer.path();

    case "IDENTITY":
      return salesRoutes.weryfikacjaTozsamosci.path();

    case "IDENTITY_ERROR":
      return salesRoutes.panel.path();

    case "IDENTITY_PENDING":
      return salesRoutes.panel.path();

    case "PAYMENT_METHOD":
      return salesRoutes.platnosc.path();

    case "APPOINTMENT":
      return salesRoutes.terminInstalacji.path();

    case "CONSENTS":
      return salesRoutes.zgody.path();

    case "ORDER_SUMMARY":
      return salesRoutes.podsumowanie.path();

    case "DELIVERY":
      return salesRoutes.sposobDostawy.path();

    case "LEGACY_FEASIBILITY_PENDING":
      return salesRoutes.migracjaNumeru.sprawdzMozliwoscMigracji.path();

    case "LEGACY_MIGRATION":
      return salesRoutes.migracjaNumeru.akceptacjaWarunkow.path();

    case "LEGACY_MIGRATION_PENDING":
      return salesRoutes.migracjaNumeru.prawieGotowe.path();

    case "LEGACY_MIGRATION_ERROR":
      return salesRoutes.migracjaNumeru.migracjaNiemozliwa.path();

    case "MNP":
      return salesRoutes.migracjaNumeru.typOfertyMobilnej.path();

    default:
      return salesRoutes.panel.path();
  }
}
